export default __webpack_public_path__ + "static/LandBlock1-2f266738e80d333e0131f56ccb0e724d.png";